var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend"},[_c('div',{staticClass:"legend-items"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"legend-item"},[_c('div',{staticClass:"legend-color",style:({ backgroundColor: item.color })}),_vm._v("\n      "+_vm._s(item.label)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }